import { useEffect, useState } from 'react';
import { captureException } from '@sentry/nextjs';

import { User } from 'types';
import { LOGIN_REQUIRED } from 'utils/client/auth/errorMessages';

export const useCustomer = () => {
  const [user, setUser] = useState<User | null>(null);
  const [isFetching, setIsFetching] = useState<boolean>(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // Inline import since the auth lib only works in browsers
        const auth = (await import('utils/client/auth/auth')).default;
        const response = await auth.fetch('https://api.spotify.com/v1/me', {});

        // We need to check if the response is ok for status 404 and 500 because fetch doesn't throw an exception.
        if (!response.ok) {
          throw new Error(`Problem fetching "/v1/me": ${response.status.toString()}`);
        }

        const userFetched: User = await response.json();
        setUser(userFetched);
      } catch (e) {
        // Exclude exception in sentry when user is not logged in
        if (e.error !== LOGIN_REQUIRED) captureException(e);
      }

      setIsFetching(false);
    };

    fetchUser();
  }, []);

  return {
    isFetching,
    user,
  };
};
